import api from '../../services/api';
import { Creators } from '../ducks/port';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getPorts({ filter }) {
  try {
    let response; 

    yield put(Creators.portRequest());
    response = yield call(api.post, 'port', filter);

    yield put(Creators.portSuccess(filter.chip, response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.portError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar portes'
    }));
  }
} 